<template>
  <div
    class="w-full md:flex md:justify-center md:py-10 h-[500px] md:h-[600px] lg:h-[500px]"
  >
    <div
      class="bg-gradient-to-b from-[#0F2377] to-[#00102F] h-[220px] md:h-[295px] w-full md:rounded-b-[40px]"
    >
      <section
        class="w-full max-w-7xl mx-auto relative overflow-x-hidden xl:overflow-visible z-40"
      >
        <div class="flex flex-col md:gap-3 text-left md:text-center p-5 lg:p-0">
          <h2
            class="text-[#f8c300] font-semibold text-[24px] lg:text-[35px] mt-3"
          >
            Admission Process
          </h2>
          <p class="text-white text-[14px] lg:text-[18px]">
            Applying for admission into our programs has never been simpler -
            just follow these steps!
          </p>
        </div>

        <div>
          <div class="md:mt-8">
            <div class="slick_addmission flex flex-wrap justify-center gap-6">
              <div
                v-for="addmission in addmissions"
                :key="addmission.id"
                class="px-5 lg:px-0"
              >
                <div
                  class="bg-white h-[190px] lg:w-[340px] mx-auto border flex flex-col gap-5 p-5 text-left rounded-xl"
                >
                  <h2 class="text-[#001C54] text-[18px] font-bold">
                    {{ addmission.head }}
                  </h2>
                  <h3 class="text-black font-bold">
                    {{ addmission.content1 }}
                  </h3>
                  <p class="text-[14px]" v-html="addmission.content2">
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="absolute lg:top-7 top-0 right-[-72px] lg:right-[-140px] md:right-0 lg:-z-10"
        >
          <img
            src="@/assets/electiveDetail/Path.png"
            alt=""
            class="w-[113px] h-[113px] lg:w-[232px] lg:h-[232px]"
          />
        </div>
        <div class="py-5 px-5">
          <a :href="dynamicHref" target="blank">
            <button
              class="text-[#001C54] lg:py-3 lg:px-7 py-3 w-full md:w-[150px] rounded-full bg-[#F8C300] font-bold"
              @click="handleApplyNowClick"
            >
              Apply Now
            </button>
          </a>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import "slick-carousel";
export default {
  name: "AddmissionProcess",
  props:["widget_id"],
  data() {
    return {
      addmissions: [
        {
          id: 1,
          head: "Step 1",
          content1: "Submit Application",
          content2:
            '<a href="https://application.onlinejain.com/" target="_blank" rel="noopener noreferrer" class="underline">Click here</a> to visit the JAIN Online enrollment form',
        },
        {
          id: 2,
          head: "Step 2",
          content1: "Enroll for the elective",
          content2:
            "Sign up and complete the 4 essential steps to enroll in the program of your choice",
        },
        {
          id: 3,
          head: "Step 3",
          content1: "Make Payment",
          content2:
            "Pay fees through Net banking/Debit card/Credit card or using easy EMI with 0% interest",
        },
      ],
    };
  },
  computed: {
    dynamicHref() {
      const currentPath = this.$route.path;
      // if (currentPath === "/online-mba/data-science") {
      //   return "https://onlinejain.com/gl/mba-data-science-digital-marketing-jain-registration.html?utm_source=university_website&utm_medium=second_scroll&utm_campaign=applynow_onlinejain";
      // } else if (
      //   currentPath === "/online-mba/digital-marketing-and-ecommerce"
      // ) {
      //   return "https://onlinejain.com/gl/mba-data-science-digital-marketing-jain-registration.html?utm_source=university_website&utm_medium=second_scroll&utm_campaign=applynow_onlinejain";
      // } else if (currentPath === "/online-bba/digital-marketing") {
      //   return "https://onlinejain.com/gl/bba-degree-jain-online-registration.html?utm_source=university_website&utm_medium=second_scroll&utm_campaign=applynow_onlinejain";
      // } else if (currentPath === "/online-bba/data-science-and-analytics") {
      //   return "https://onlinejain.com/gl/bba-degree-jain-online-registration.html?utm_source=university_website&utm_medium=second_scroll&utm_campaign=applynow_onlinejain";
      // } else if (currentPath === "/online-mca/full-stack-development") {
      //   return "https://onlinejain.com/gl/jain-online-master-of-computer-applications-registration.html?utm_source=university_website&utm_medium=second_scroll&utm_campaign=applynow_onlinejain";
      // } else if (currentPath === "/online-mca/cloud-computing") {
      //   return "https://onlinejain.com/gl/jain-online-master-of-computer-applications-registration.html?utm_source=university_website&utm_medium=second_scroll&utm_campaign=applynow_onlinejain";
      // } else if (currentPath === "/online-mca/data-science") {
      //   return "https://onlinejain.com/gl/jain-online-master-of-computer-applications-registration.html?utm_source=university_website&utm_medium=second_scroll&utm_campaign=applynow_onlinejain";
      // } else if (currentPath === "/online-mca/artificial-intelligence") {
      //   return "https://onlinejain.com/gl/jain-online-master-of-computer-applications-registration.html?utm_source=university_website&utm_medium=second_scroll&utm_campaign=applynow_onlinejain";
      // } else {
      //   return "https://apply.onlinejain.com/";
      // }
      if (this.widget_id!=null && this.widget_id!='') {
        return `https://application.onlinejain.com/?id=${this.widget_id}`;
      } else {
        return "https://application.onlinejain.com/";
     
      }
     
    },
  },
  mounted() {
    $(`.slick_addmission`).slick({
      infinite: true,
      autoplay: true,
      prevArrow: false,
      nextArrow: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: true,
      dotsClass: "slick-dots",

      responsive: [
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 950,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 650,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  },
  methods: {
    handleApplyNowClick() {
      dataLayer.push({
        event: "Apply Online Initiated",
        Attribute: {
          CTA: "Apply Now",
          "Section Name": "Admission Process",
        },
      });
      console.log("window.dataLayer::::", window.dataLayer);
    },
  },
};
</script>

<style></style>
